import { graphql, useStaticQuery } from 'gatsby';
import BackgroundImage from 'gatsby-background-image';
import Img from 'gatsby-image';
import React from 'react';
import './Fall.scss';
import { AppData } from '@models/home';

const Fall: React.FC<{ appData: AppData; reversed?: boolean }> = ({ appData, reversed }) => {
  const images = useStaticQuery(graphql`
    query {
      appImages: allFile(filter: { relativeDirectory: { eq: "apps" } }) {
        edges {
          node {
            name
            extension
            childImageSharp {
              fluid(maxHeight: 1000, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
                ...GatsbyImageSharpFluidLimitPresentationSize
              }
            }
          }
        }
      }
      googlePlay: file(relativePath: { eq: "google-play.png" }) {
        childImageSharp {
          fluid(maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      cafeBazaar: file(relativePath: { eq: "cafe-bazar.png" }) {
        childImageSharp {
          fluid(maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  const appImages = images.appImages.edges.reduce((res, n) => ({ ...res, [`${n.node.name}.${n.node.extension}`]: n.node }), {});

  return (
    <section className="app-section">
      <BackgroundImage fluid={appImages[appData.bg].childImageSharp.fluid} fadeIn>
        <div className="container">
          <div className={'row justify-content-around align-items-center wrapper-padding ' + (reversed ? 'flex-row-reverse' : '')}>
            <div className="col-12 col-md-6 order-0">
              <div className="d-flex align-items-center">
                <Img className="app-icon" fluid={appImages[appData.logo].childImageSharp.fluid} alt="fall" />
                <h1 className="app-name">{appData.name}</h1>
              </div>
              <div className="text-justify my-4">
                <p className="app-desc">{appData.desc}</p>
              </div>
              <div className="row justify-content-center">
                {appData.cafebazaar && (
                  <div className="col-6">
                    <a href={appData.cafebazaar} target="_blank">
                      <Img fluid={images.cafeBazaar.childImageSharp.fluid} alt="fall" />
                    </a>
                  </div>
                )}

                {appData.googlePlay && (
                  <div className="col-6">
                    <a href={appData.googlePlay} target="_blank">
                      <Img fluid={images.googlePlay.childImageSharp.fluid} alt="fall" />
                    </a>
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 col-md-6 order-1">
              <Img
                className={(appData.landscape ? 'landscape-mobile' : 'portrait-mobile') + ' mx-auto'}
                fluid={appImages[appData.mobile].childImageSharp.fluid}
                alt="fall"
              />
            </div>
          </div>
        </div>
      </BackgroundImage>
    </section>
  );
};

export default Fall;
